/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { SuggestionMessage } from './model/suggestion-message.model';
import {
  courierAddFromPopup,
  courierEditFromPopup,
  customerContractAddUrl,
  customerOfferRequestNewUrl,
  customerSmallProfileUrl,
  myCompanyContactNewUrl,
  partnerContactNewUrl,
  spOfferRequestNewUrl,
  transportProjectUrl
} from '@well/navigation';

export const salesNotFound: SuggestionMessage = {
  description: 'crm-app.suggestions.salesNotFound',
  navigationUrl: ['/', 'crm', 'sales', 'new'],
};

export const companyNotServiceProvider: SuggestionMessage = {
  description: 'crm-app.suggestions.companyNotServiceProvider',
  navigationUrl: ['company/my-company/details'],
};

export const missingEmployee: SuggestionMessage = {
  description: 'crm-app.suggestions.missingEmployee',
  navigationUrl: ['/', { outlets: { popup: ['popup', 'company', 's', 'my-company', 'employee', 'new'] } }],
};

export const employeeListPage : SuggestionMessage = {
    description: 'delivery-app.suggestions.employeeList',
    navigationUrl: ['/', 'company', 'my-company', 'employee', 'list'],

};

export const transportProjectListPage : SuggestionMessage = {
    description: 'delivery-app.suggestions.transportProjectList',
    navigationUrl: transportProjectUrl,
};
export const missingServicesForOpportunity = (uuid: any): SuggestionMessage => {
  return {
    description: 'crm-app.suggestions.missingServicesForOpportunity',
    navigationUrl: customerSmallProfileUrl(uuid),
  };
};

export const editActivitySuggestion = (uuid: string): SuggestionMessage => {
  return {
    description: 'crm-app.suggestions.editActivitySuggestion',
    navigationUrl: ['/', 'crm', 'activity', 'detail', uuid],
  };
};

export const editOpportunitySuggestion = (uuid: string): SuggestionMessage => {
  return {
    description: 'crm-app.suggestions.editOpportunitySuggestion',
    navigationUrl: ['/', 'crm', 'opportunity', 'detail', uuid],
  };
};

export const addAccount: SuggestionMessage = {
  description: 'delivery-app.suggestions.addAccount',
  navigationUrl: ['/', { outlets: { popup: ['popup', 'delivery', 's', 'account', 'new'] } }],
};

export const addVendorTag: SuggestionMessage = {
  description: 'delivery-app.suggestions.addVendorTag',
  navigationUrl: ['/', { outlets: { popup: ['popup', 'delivery', 's', 'vendor-tag', 'new'] } }],
};

export const customerOrderListPage: SuggestionMessage = {
  description: 'delivery-app.suggestions.orderListPage',
  navigationUrl: customerOfferRequestNewUrl,
  queryParams: { allowCustomerSelection: false, allowVendorSelection: true, context: 'customer-order-list' },
};

export const spOrderListPage: SuggestionMessage = {
  description: 'delivery-app.suggestions.orderListPage',
  navigationUrl: spOfferRequestNewUrl,
  queryParams: { allowCustomerSelection: true, allowVendorSelection: false, context: 'sp-order-list' },
};

export const addBankAccount: SuggestionMessage = {
  description: 'delivery-app.suggestions.addBankAccount',
  navigationUrl: ['company', 'my-company', 'bank-account', 'list'],
};

export const addBankAccountPopup = (queryParams?: any): SuggestionMessage => {
  return {
    description: 'delivery-app.suggestions.addBankAccount',
    navigationUrl: ['/', 'company', 'my-company', 'bank-account', 'list'],
    queryParams: queryParams,
  };
};

export const addBankAccountForPartnerPopup = (legalEntityUuid: string, queryParams?: any): SuggestionMessage => {
  return {
    description: 'delivery-app.suggestions.addBankAccountForPartnerPopup',
    queryParams: queryParams,
  };
};

export const addCustomer = (queryParams?: any): SuggestionMessage => {
  return {
    description: 'delivery-app.suggestions.addCustomer',
    navigationUrl: ['/', { outlets: { 'popup-full': ['popup-full', 'crm', 's', 'customer', 'new'] } }],
    queryParams: queryParams,
  };
};

export const addVendor = (queryParams?: any): SuggestionMessage => {
  return {
    description: 'delivery-app.suggestions.addVendor',
    navigationUrl: ['/', { outlets: { 'popup-full': ['popup-full', 'delivery', 's', 'vendor', 'new'] } }],
    queryParams: queryParams,
  };
};

export const assetSuggestion: SuggestionMessage = {
  description: 'company.suggestions.addLogoAsset',
  navigationUrl: ['/', 'company', 'my-company', 'details'],
};

export const addCrmContact = (uuid: string): SuggestionMessage => {
  return {
    description: 'crm-app.suggestions.addContact',
    navigationUrl: ['/', 'crm', 'customer', 'contacts', uuid]
  }
}

export const addCompanyContact = (bpUuid:string): SuggestionMessage =>{
  return {
    description: 'company.suggestions.addCompanyContact',
    navigationUrl:partnerContactNewUrl(bpUuid),
  }
}

export const eTransportShipmentDate: SuggestionMessage = {
  description: 'etransport.form.shipmentData.shipmentDateTooltip'
};

export const eTransportModifVehicleModificationDate: SuggestionMessage = {
  description: 'etransport.modifVehicle.modifyDateSuggestion'
};

export const addExternalVendor = (): SuggestionMessage =>{
  return {
    description: 'delivery-app.suggestions.addExternalVendor',
    navigationUrl: courierAddFromPopup,
  }
}

export const addCustomerContract = (): SuggestionMessage => {
  return {
    description: 'delivery-app.supplierDelegationManagement.form.contractsSuggestionMessage',
    navigationUrl: customerContractAddUrl,
  }
}

export const addMyCompanyContact = (description: string): SuggestionMessage => {
  return {
    description: description,
    navigationUrl: myCompanyContactNewUrl,
  }
}

export const editFedExExternalVendorRequestCredentials = (fedExExternalVendorUuid: string): SuggestionMessage =>{
  return {
    description: 'delivery-app.order.orderShipperAndPaymentPartiesPopup.shouldAddUploadTradeDocumentCredentials',
    navigationUrl: courierEditFromPopup(fedExExternalVendorUuid)
  }
}

export const SuggestionMessageState = {
  assetSuggestion,
  addVendor,
  addCustomer,
  addBankAccountForPartnerPopup,
  addBankAccountPopup,
  addBankAccount,
  spOrderListPage,
  customerOrderListPage,
  addVendorTag,
  addAccount,
  editOpportunitySuggestion,
  editActivitySuggestion,
  missingServicesForOpportunity,
  missingEmployee,
  employeeListPage,
  companyNotServiceProvider,
  salesNotFound,
  addCrmContact,
  eTransportShipmentDate,
  transportProjectListPage,
  eTransportModifVehicleModificationDate,
  addCompanyContact,
  addExternalVendor,
  editFedExExternalVendorRequestCredentials,
  addCustomerContract,
  addMyCompanyContact
};
